module.exports = __webpack_public_path__ + "img/四川天府新区白沙中学.e053811f.jpg";